<div class="content-container">
    <div class="header-padding">
		<div class="header-container">
			<div class="report-info">
				<h2 class="report-title">Database</h2>
				<p class="report-subtitle">
					<span class="subtitle-span">Drill & Blast Collection</span> - visualizes 
				</p>
			</div>
            <mat-form-field class="drill-search" appearance="outline">
                <mat-label>Search</mat-label>
                <input matInput #searchInput (keyup)="applyFilter(searchInput.value)">
            </mat-form-field>
            <div class="actions-container">
                <div class="filter" [matTooltip]="'Filter'" (click)="showModal = !showModal;$event.stopPropagation()">
                    <mat-icon>
                        filter_list
                    </mat-icon>
                </div>
                <div *ngIf="showModal" >
                    <mat-card class="filter-card">
                        <mat-card-header class="flex-row card-header">
                            <mat-card-title>
                                <div class="filter-title">
                                    <h3>
                                        Filter Options
                                    </h3>
                                    <mat-icon class="close-btn" [matTooltip]="'Close'" (click)="showModal =! showModal">
                                        close
                                    </mat-icon>
                                </div>
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content (click)="$event.stopPropagation()">
                            <div class="filter-container flex-column gap-small">
                                <mat-checkbox *ngFor="let data of filterValues"
                                    [(ngModel)]="data.value" 
                                    color="primary"
                                    (change)="onApplyFilter()"
                                >
                                    {{data.name}}
                                </mat-checkbox>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
			<div class="export-btn">
                <button mat-raised-button color="primary" class="import-btn" (click)="importAsExcel()"><mat-icon svgIcon="importIcon" class="svg-icon"></mat-icon>Import as Excel</button>
                <input  type="file" #fileInput style="display: none" (change)="onFileChange($event)" />
    
                <button mat-raised-button class="import-btn" color="primary" (click)="downloadToExcel('exportExcel')"><mat-icon svgIcon="exportIcon" class="svg-icon"></mat-icon>Export as Excel</button>
                <button mat-raised-button class="primary export-pdf-btn" color="primary" (click)="downloadToExcel('downloadSample')"><mat-icon svgIcon="downloadSampleIcon" class="svg-icon"></mat-icon>Download Sample</button>
			</div>
		</div>        
	</div>
    <div class="excel-style-container">
        <div class="table-container">
            <table class="data mat-elevation-z1 excel-table" mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="datasetName" sticky>
                    <th mat-header-cell *matHeaderCellDef>Project</th>
                    <td mat-cell *matCellDef="let element" #cell>
                        <mat-select  *ngIf="!element.isRecordExist && !element.apiV2DatasetId" [(ngModel)]="selectedDataset" (selectionChange)="onDatasetSelect($event)">
                            <mat-option *ngFor="let dataset of datasetNames" [value]="dataset">{{ dataset.blast }}</mat-option>
                        </mat-select>
                        <span class="xs-display" *ngIf="element.isRecordExist || element.apiV2DatasetId">{{element.blast}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="blastReportUrl">
                    <th mat-header-cell *matHeaderCellDef>Blast Report URL</th>
                    <td mat-cell *matCellDef="let element">
                        <input type="text" matInput [(ngModel)]="element.blastReportUrl" *ngIf="!element.isRecordExist && !element.apiV2DatasetId" />
                        <a class="xs-display" [href]="element.blastReportUrl" target="_blank" *ngIf="element.isRecordExist || element.apiV2DatasetId">{{element.blastReportUrl}}</a>
                    </td>
                </ng-container>

				<ng-container *ngFor="let col of dataSourceSchema">
					<ng-container *ngIf="getDisplayedColumns().includes(col.key)" [matColumnDef]="col.key">
						<th mat-header-cell *matHeaderCellDef>
							{{ col.label == 'Average Charge' ? (col.label | UnitDisplayPipe : userUnitMeasurement : col.valueUnit) + '/hole' : (col.label | UnitDisplayPipe : userUnitMeasurement : col.valueUnit) }}
						</th>

						<td mat-cell *matCellDef="let element">
							<input [type]="col.type" matInput [ngModel]="element[col.key] | UnitConversionPipe : userUnitMeasurement : col.valueUnit"
								readonly="true"
								(focus)="onFieldInputClick($event, col, element)"
								[required]="col.required"
								(ngModelChange)="onFieldInputChange(element, col.key, $event, col.valueUnit, col.type)" 
							/>
						</td>
					</ng-container>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: getDisplayedColumns();"></tr>

			</table>
		</div>
	</div>
    
    <div class="actions-button-container">
        <div class="actions-button" *ngIf="domainId">
            <button
                mat-raised-button
                color="primary"
                class="add-row"
                (click)="onSaveOrAddRow()"
            ><mat-icon svgIcon="addIcon" class="svg-icon"></mat-icon>
                {{ isNewRow ? "Save" : "Add Row" }}
            </button>
            <button
                mat-raised-button
                color="primary"
                *ngIf="isNewRow"
                class="add-row"
                (click)="removeRow()"
            >
                Remove
            </button>
        </div>
        <mat-paginator
            pageSize="30"
            [pageSizeOptions]="[30, 40]"
            hidePageSize="true"
        >
        </mat-paginator>
    </div>
</div>

<div class="loading-container" *ngIf="loadingDrillData">
    <mat-spinner matTooltip="Loading Drill Data Collection View"></mat-spinner>
</div>
